exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro-box--wrapper{display:flex;flex-grow:1;flex-direction:column;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8)}.intro-box--wrapper .intro-box--content{position:relative;z-index:999;margin:0 auto 30px;flex-grow:1;width:350px;height:350px;display:block;justify-content:center;flex-direction:column;background-color:#fff}.intro-box--wrapper .intro-box--content p{color:#fff;text-align:center;font-size:23px;line-height:34px;font-weight:500}.intro-box--wrapper .intro-box--content span{font-size:34px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ded4fdc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InAppBrowserTurorial.vue
// module id = 239
// module chunks = 0